var apiHelper = require('../../api');
var helper = require('../../helper');
var loaderInstance = require('../../loader');
var $loaderContainer = document.querySelector('.paypalLoader');
var loader = loaderInstance($loaderContainer);

/**
 *  Appends error message on cart page
 *
 * @param {string} message error message
 */
function showCartErrorHtml(message) {
    $('.checkout-btn').addClass('disabled');
    $('.cart-error').append(
        `<div class="alert alert-danger alert-dismissible valid-cart-error fade show cartError" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            ${message}
        </div>`
    );
    window.scrollTo(0, 0);
}

function onClick() {
    $('body').trigger('analytics:dataLayerPushObj', {
        event: 'custom_event',
        eventCategory: 'checkout',
        eventAction: 'fast',
        eventLabel: 'Paypal Express',
        accessType: 'minicart'
    });
}

/**
 *  Gets order id as string
 *
 * @returns {string} order id
 */
function createOrder() {
    return apiHelper.getPaypalOrderId();
}

/**
 *  Makes post call and transfers order ID to returnFromCart endpoint, goes to ty page, if an error occurs, the user is redirect to Checkout-Begin 
 *
 * @param {Object} orderID - order id
 */
function onApprove(fieldsData) {
    // make sure that amount > 0
    var $defer = $.Deferred();
    $.get(window.paypalUrls.getCartPurchaseUnit)
        .then(function ({ purchase_units }) {
            let parsedPurchaseUnit = purchase_units[0];
            if (JSON.parse(parsedPurchaseUnit.amount.value) === 0) {
                showCartErrorHtml('Order total 0 is not allowed for PayPal');
                $defer.reject();
            } else {
                $defer.resolve();
            }
        })
        .fail(function(){
            $defer.reject();
        });
    
    
    let cartBillingFormData = apiHelper.createCartBillingFormData(fieldsData,
        document.querySelector('.js_paypal_button_on_minicart_page'));

    $defer.done(function(){
        $.ajax({
            type: 'POST',
            url: window.paypalUrls.returnFromCart,
            contentType: false,
            data: cartBillingFormData,
            processData: false,
            success: () => {
                loader.hide();
                $.spinner().start();
    
                // validate shipping
                $.ajax({
                    type: 'GET',
                    url: window.paypalUrls.validateShipping,
                    success: (data) => {
                        if (data.error && data.countryMatchError) {
                            // redirect to Checkout-Begin shipping stage
                            window.location.href = data.redirectUrl;
                        } else {
                            // validate billing
                            $.ajax({
                                type: 'GET',
                                url: window.paypalUrls.billingStep,
                                success: (data) => {
                                    var continueUrl = data.continueUrl;
                                    var urlParams = {
                                        ID: data.orderID,
                                        token: data.orderToken
                                    };
                                    
                                    continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?') +
                                        Object.keys(urlParams).map(function (key) {
                                            return key + '=' + encodeURIComponent(urlParams[key]);
                                        }).join('&');
                                    
                                    // redirect to TYP
                                    window.location.href = continueUrl;
                                },
                                error: (data) => {
                                    $.spinner().stop();
                                    // todo paypal: show billing error message
                                }
                            });
                        }
                    },
                    error: function(data) {
                        $.spinner().stop();
                        // todo paypal: show shipping error message
                    }
                });
            },
            error: function () {
                loader.hide();
                if (window.location.href !== window.paypalUrls.cartPage) {
                    window.location.href = window.paypalUrls.cartPage;
                }
                if (!document.querySelector('.cartError')) {
                    // todo paypal: translate error message
                    apiHelper.showCartErrorHtml('An internal server error has occurred. \r\nRetry the request later.');
                }
            }
        });
    });
}

/**
 * Hides loader on paypal widget closing without errors
 */
function onCancel() {
    loader.hide();
}

/**
 * Shows errors if paypal widget was closed with errors
 */
function onError() {
    loader.hide();
    if (window.location.href !== window.paypalUrls.cartPage) {
        window.location.href = window.paypalUrls.cartPage;
    }
    if (!document.querySelector('.cartError')) {
        showCartErrorHtml('An internal server error has occurred. \r\nRetry the request later.');
    }
}

/**
 *Inits paypal button on cart page
 */
function initPaypalButton() {
    loader.show();
    window.paypal.Buttons({
        onClick,
        createOrder,
        onApprove,
        onCancel,
        onError,
        style: helper.getPaypalButtonStyle(document.querySelector('.js_paypal_button_on_minicart_page'))
    }).render('.paypal-minicart-button')
        .then(() => {
            loader.hide();
        });
}

module.exports = {
    initPaypalButton: initPaypalButton
}
